module.exports = __webpack_public_path__ + "img/PXL_20230519_183737587.60343ecb.jpg";